import React from "react";
import { sidemenuFooterWrap } from "../componentCommon";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";
import "./Artists.scss";

const ArtistsData = () => (
  <Container
    className="container-artists"
    sm={{ span: 12 }}
    md={{ span: 12 }}
    lg={{ span: 12 }}
    xl={{ span: 12 }}
  >
    <Row>
      <Col
        sm={{ span: 12 }}
        md={{ span: 11, offset: 1 }}
        lg={{ span: 11, offset: 1 }}
        xl={{ span: 11, offset: 0 }}
      >

        <div style={{ alignText: "center", fontFamily: "Verdana, arial" }} className="artists-title">
        UMETNIČKI PRAVCI I POJAVE
        </div>

        <Row className="artists-r">
          <Col md={{ span: 10 }}>
            <Row>
              <div style={{ alignItems: "center" }}>
                <Row
                  xs={{ span: 12 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                >
                  <Col
                    xs={{ span: 12 }}
                    sm={{ span: 12 }}
                    md={{ span: 12 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                  >
                    <Link to="/g/avangarda" className="im-link">
                      <img src="images/04_avangarda_srednja2.jpg" alt="avangarda, citajte o" />
                    </Link>
                  </Col>
                  <Col
                    xs={{ span: 10 }}
                    sm={{ span: 7, offset: 0 }}
                    md={{ span: 7, offset: 0 }}
                    lg={{ span: 5, offset: 1 }}
                    xl={{ span: 6, offset: 0 }}
                  >
                    <div className="artist-p avangarda-p" >
                    <font color="black">
                        <b>AVANGARDA</b>
                        <br />
                      </font>
                      - U februaru počinje da izlazi časopis <i>Zenit</i> –
                      Internacionalna revija za umetnost i kulturu. Urednik Ljubomir
                      Micić. U prvom broju časopisa <i>Zenit</i> izlazi{" "}
                      <i>Zenitistički manifest</i> Ivana Golla pisan na nemačkom i{" "}
                      <i>Manifest zenitizma</i> čiji su potpisnici Ljubomir Micić,
                      Ivan Goll i Boško Tokin. <i>Zenit</i> uspostavlja aktivnu
                      saradnju sa Arhipenkom osnivačem umetničke škole u Berlinu.{" "}
                      <br />- Branko Ve Poljsnski i Dragan Aleksić u Pragu priređuju
                      zenitističke i dadaističke manifestacije. Osnovan umetnički
                      klub <i>Zenit</i>. <br />- Zenitovi saradnici u prvoj polovini
                      godine objavljuju značajna dela: Rastko Petrović{" "}
                      <i>Bruleska gospodina Peruna boga groma</i>, Miloš Crnjanski{" "}
                      <i>Dnevnik o Čarnojeviću</i>, Stanislav Vinaver{" "}
                      <i>Gromobran Svemira</i>, Miroslav Krleža{" "}
                      <i>Marginalije uz slike Petra Dobrovića</i>. Izlazi revija za
                      filmsku kulturu <i>Kinofon</i>, urednik Valerij Poljanski
                    </div>
                  </Col>
                </Row>
              </div>              
              
            </Row>
          </Col>
        </Row>

      </Col>    
    </Row>

  </Container>
);

const Artists = sidemenuFooterWrap(ArtistsData);
export default Artists;
